import { openMcpShellLogin } from './flows/mcpShellRedirect'

import { useAccount } from '@/features/account'

/** Opens mcp.orphex.co on the account currently selected in this app (ORP-27467). */
export const openOrphexMcp = (): Promise<void> =>
  openMcpShellLogin(useAccount().accountId.value ?? null)

/**
 * The web user's one way into mcp.orphex.co (ORP-27467), placed right under Summary in both the
 * paid and the Free menu. It is never locked — the MCP has its own free tier — and never shows as
 * selected: it opens another tab and the user stays where they were.
 *
 * `action` runs inside the click itself (sidebar, navigation search), which is what lets the tab
 * through a popup blocker.
 */
export const orphexMcpNavItems = [
  {
    labelKey: 'shell.nav.orphexMcp',
    badgeKey: 'shell.nav.new',
    icon: 'plug',
    navKey: 'orphexMcp',
    action: openOrphexMcp,
    opensInNewTab: true,
  },
]
